import Main from "./pages/Main/Main";

const App = () => {
   return <Main />;
};

export default App;
